import React, { useState } from "react";
import "./ProductUploadForm.css";
import { DialogTitle } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import Snackbar from "@mui/material/Snackbar";
import Stack from "@mui/material/Stack";
import { blue } from "@mui/material/colors";
import { Resend } from "resend";
import axios from "axios";
import { useEffect } from "react";
import Product from "../Product";
import { storage } from "../firebase";
import {
  ref as storageRef,
  uploadBytesResumable,
  getDownloadURL,
} from "firebase/storage";
import { collection, addDoc } from "firebase/firestore";
import { db as database } from "../firebase";
import { useNavigate, useNavigation } from "react-router-dom";
import { getDocs } from "firebase/firestore";
import { useAlert } from "react-alert";
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={50} ref={ref} variant="filled" {...props} />;
});

export default function ProductUploadForm() {
  const navigate = useNavigate();
  const alert = useAlert();
  const [open, setOpen] = React.useState(false);
  const [isYes, setIsYes] = React.useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const instanceResend = new Resend("re_iJbFjdoT_49P2jyU8fEfp6zYr8YK5V1ao");
  const [file, setFile] = useState(null);
  const [percent, setPercent] = useState(0);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [mediaURL1, setMediaURL1] = useState("");
  const [mediaURL2, setMediaURL2] = useState("");
  const [mediaURL3, setMediaURL3] = useState("");
  const [mediaURL4, setMediaURL4] = useState("");
  const [mediaURL5, setMediaURL5] = useState("");
  const [mediaURLCount, setMediaURLCount] = useState(1);
  const [mediaURLType, setMediaURLType] = useState("");
  const [files, setFiles] = useState([]);
  const [fileType, setFileType] = useState("");
  const [sellers, setSellers] = useState([]);
  const [sellerId, setSellersId] = useState("");
  let sellerList;
  const [newItem, setNewItem] = useState({
    id: "1",
    title: "Not for sale",
    sellerEmail: "",
    sellerPhone: "",
    price: 99.99,
    rating: 4,
    ratings: 72,
    image: "../images/bag.jpeg",
    itemWeight: "",
    packageWeight: "",
    numberOfItems: 1,
    unitCount: "1",
    description1: "Default image for testing only",
    categories: "Milano",
    measure: "",
    status: "active",
    shipping: 9.99,
    tax: 0.0,
    promotion: "",
  });
  const handleFileChange = (e) => {
    e.preventDefault();
    const selectedFile = e.currentTarget.files?.[0] ?? null;
    if (selectedFile) {
      setFile(selectedFile);
      setFileType(selectedFile.type);
    }
  };

  const handleUpload = (e) => {
    e.preventDefault();
    if (!file) {
      alert.show("Please select a file first!");
      return;
    }

    const blob = file instanceof Blob ? file : null;
    if (!blob) {
      // console.error("Selected file is not a Blob object.");
      return;
    }

    const fileName = `${Date.now()}_${file.name}`;
    const storageReference = storageRef(storage, `uploads/${fileName}`);
    const uploadTask = uploadBytesResumable(storageReference, blob);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        const perc = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        setPercent(perc);
      },
      (error) => {
        alert.show("Something is not right...Do you have internet ?");
        // console.error("Upload failed:", error);
      },
      () => {
        getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
          setDownloadUrl(downloadURL);
          setMediaURLType(fileType);
          if (mediaURLCount === 1) {
            setMediaURL1(downloadURL);
            alert.show("First image uploaded !");
          }
          if (mediaURLCount === 2) {
            setMediaURL2(downloadURL);
            alert.show("Second image uploaded !");
          }
          if (mediaURLCount === 3) {
            setMediaURL3(downloadURL);
            alert.show("Third image uploaded !");
          }
          if (mediaURLCount === 4) {
            setMediaURL4(downloadURL);
            alert.show("Fort image uploaded !");
          }
          if (mediaURLCount === 5) {
            setMediaURL5(downloadURL);
            alert.show("Fifth ( the last ) image uploaded !");
          }

          // setImage("");
          // setVideo("");
        });
        setMediaURLCount(mediaURLCount + 1);
      }
    );
  };
  const onSubmit = async (e) => {
    e.preventDefault();
    try {
      if (!(sellerId && mediaURL1)) return; // must save atleast 1 image
      await saveRecord(
        sellerId,
        mediaURLType,
        mediaURL1,
        mediaURL2,
        mediaURL3,
        mediaURL4,
        mediaURL5,
        new Date().toISOString()
      );
      alert.show("detail saved succesfully !");

      setMediaURL1("");
      setMediaURL2("");
      setMediaURL3("");
      setMediaURL4("");
      setMediaURL5("");
      setDownloadUrl("");
      setPercent(0);
      handleClose();
      setNewItem(null);
      // close the form screen
      // navigation.navigate("/Listfirestore");
    } catch (error) {
      alert.show("Something went wrong 1");
      // alert.show("Error Adding Data");
    }
  };
  async function saveRecord(
    sellerId,
    fileType,
    media1,
    media2,
    media3,
    media4,
    media5
  ) {
    try {
      // ////////////////////////////////////////////////////////////////////////
      //
      // SOME FIELD VALUES MUST BE GENERATED BY THE SYSTEM. NOT MANUALLY INPUTED
      ///////////////////////////////////////////////////////////////////////////
      const createdAt = new Date().getTime();
      const id = createdAt;
      const tax = 0.0;
      const item = {
        ...newItem,
        id,
        sellerId,
        fileType,
        image1_url: media1,
        image2_url: media2,
        image3_url: media3,
        image4_url: media4,
        image5_url: media5,
        createdAt,
        tax,
      };
      //
      ///////////////////////////////////////////////////////////////////////////
      const docRef = await addDoc(collection(database, "ProductTable"), item);
      //
      // console.log("document saved correctly", docRef.id); // navigation.navigate("Listfirestore");
    } catch (error) {
      // console.log(error);
      alert.show("Something went wrong !");
    }
  }
  /////////////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////////

  const handleYesClick = () => {
    setIsYes(true);
    setOpen(false);
  };
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setIsYes(false);
    navigate("/Home");
  };

  useEffect(() => {
    const fetchSellers = async () => {
      const sellerDBRef = collection(database, "Seller");
      const sellerSnapshot = await getDocs(sellerDBRef);
      const sellerList = sellerSnapshot.docs.map((seller) => ({
        connectedAccountId: seller.connectedAccountId,
        ...seller.data(),
      }));
      setSellersId(sellerList[0]?.connectedAccountId);
      // alert.show(sellerId);
      // setNewItem({ ...newItem, sellerId });
      // setSellers(sellerList);
    }; // END OF fetchSellers()
    // //
    fetchSellers();
  }, []);

  return (
    <div className="outercontainer">
      <div
        padding="0px"
        width="98%"
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div padding={0}>
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "left",
              alignItems: "center",
              // gap: 140,
              paddingTop: "10px",
              paddingLeft: "20px",
              color: "white",
              fontSize: "1rem",
              marginTop: "120px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <br />
            <input
              type="file"
              accept="image/*,video/*"
              style={{
                height: "35px",
                borderRadius: 7,
                padding: 5,
                width: 100,
              }}
              onChange={handleFileChange}
            />
            <p
              style={{
                padding: 5,
              }}
            >
              <h6>Upload not more than Five images</h6>
            </p>
            <button
              onClick={handleUpload}
              style={{ height: "35px", borderRadius: 7, padding: 5 }}
            >
              Upload
            </button>
            {percent > 0 && (
              <p>
                <h6>:{percent}% done</h6>
              </p>
            )}
            {downloadUrl && (
              <div>
                {file.type.startsWith("image") ? (
                  <img
                    src={downloadUrl}
                    alt="uploaded"
                    style={{ maxWidth: "20px" }}
                  />
                ) : (
                  <video
                    src={downloadUrl}
                    controls
                    style={{ maxWidth: "20px" }}
                  />
                )}
              </div>
            )}
          </div>
        </div>
        <hr />
        <div className="innercontainer">
          <form
            onSubmit={onSubmit}
            className="emailForm"
            width="100%"
            style={{
              alignItems: "left",
              fontSize: "1rem",
              marginTop: "120px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
            }}
          >
            <div style={{ marginLeft: "20px", marginTop: "2px" }}>
              <h5>Enter the Product detail</h5>
              <hr />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  // padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Seller ( Your name or your company):
              </text>
              <input
                onChange={(e) =>
                  setNewItem({
                    ...newItem,
                    seller: e.target.value,
                  })
                }
                type="text"
                placeholder="Product seller"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Seller Phone Number:
              </text>
              <input
                onChange={(e) =>
                  setNewItem({
                    ...newItem,
                    sellerPhone: e.target.value,
                  })
                }
                type="number"
                placeholder=" Seller Phone Number"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Seller Email:
              </text>
              <input
                onChange={(e) =>
                  setNewItem({
                    ...newItem,
                    sellerEmail: e.target.value,
                  })
                }
                type="email"
                placeholder="Seller Email"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product category (categories :)
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, categories: e.target.value })
                }
                type="text"
                placeholder="Product category (categories)"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Title or Name :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, title: e.target.value })
                }
                type="text"
                placeholder="Product name"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "10px",
                  margin: 0,
                  marginLeft: "3px",
                  padding: "5px",
                }}
              >
                Product unit Price ( eg 34.99):
              </text>
              <input
                // multiline={false}
                onChange={
                  (e) =>
                    // floatValue = parseFloat(price: e.target.value );
                    setNewItem({
                      ...newItem,
                      price: parseFloat(e.target.value),
                    })
                  // setNewItem({ ...newItem, price: e.target.value })
                }
                type="number"
                maxLength={5}
                step="0.01"
                placeholder="Product price"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product description1 (statement1) :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, description1: e.target.value })
                }
                type="text"
                placeholder="Product  statement1"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product description2 (statement2) :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, description2: e.target.value })
                }
                type="text"
                placeholder="Product  statement2"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product description3 (statement3):
              </text>
              <input
                multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, description3: e.target.value })
                }
                type="text"
                placeholder="Product  statement3"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product description4 (statement4):
              </text>
              <input
                multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, description4: e.target.value })
                }
                type="text"
                placeholder="Product  statement4"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product description5 (statement5) :
              </text>
              <input
                multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, description5: e.target.value })
                }
                type="text"
                placeholder="Product  statement5"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Rating (stars eg 4.5):
              </text>
              <input
                multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, rating: e.target.value })
                }
                type="number"
                maxLength={4}
                step="0.01"
                placeholder="Product rating"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Ratings Count (number of raters eg 200) :
              </text>
              <input
                maxLength={6}
                type="number"
                onChange={(e) =>
                  setNewItem({ ...newItem, ratings: e.target.value })
                }
                placeholder="Product ratings count"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Weight ( in lbs) :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, itemWeight: e.target.value })
                }
                type="text"
                placeholder="Product Weight eg 1lb"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Total Package Weight :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, packageWeight: e.target.value })
                }
                type="text"
                placeholder="Package Weight eg 2lbs"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product Unit Count :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, title: e.target.value })
                }
                type="number"
                placeholder="Product Unit Count eg 1"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Total Counts :
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, numberOfItems: e.target.value })
                }
                type="number"
                placeholder="Product counts"
                style={{
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                }}
              ></input>
              <br />
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Measure
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, measure: e.target.value })
                }
                type="text"
                placeholder="measure eg 5ozs"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>
              <text
                style={{
                  width: "98%",
                  height: "20px",
                  fontSize: "12px",
                  margin: 0,
                  padding: "5px",
                  marginLeft: "1px",
                }}
              >
                Product status (active or not)
              </text>
              <input
                // multiline={false}
                onChange={(e) =>
                  setNewItem({ ...newItem, status: e.target.value })
                }
                type="active"
                placeholder="Product status"
                style={{
                  width: "98%",
                  height: "35px",
                  borderRadius: 7,
                  padding: 5,
                  fontSize: "12px",
                  margin: 0,
                  marginLeft: "1px",
                }}
              ></input>

              <button
                type="submit"
                style={{
                  height: "40px",
                  width: "99%",
                  marginTop: "30px",
                  marginBottom: "30px",
                  borderRadius: 20,
                }}
              >
                Submit Product Details
              </button>
            </div>
          </form>
          {/* //
          //
          // */}
          <div>
            {/* <DialogContentText id="alert-dialog-description"> */}
            {/* <form
              onSubmit={onSubmit}
              className="emailForm"
              width="100%"
              style={{
                alignItems: "left",
                fontSize: "1rem",
                marginTop: "2px",
                boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
              }}
            >
              <div style={{ marginLeft: "20px", marginTop: "2px" }}>
                <h5>Enter the detail</h5>
                <hr />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Apartment name:
                </text>
                <input
                  maxLength={130}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      apartment_name: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="apartment nane"
                  style={{
                    width: "98%",
                    height: "35px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Apartment summary (description):
                </text>
                <textarea
                  rows={15}
                  cols={40}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      apartment_summary: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="apartment summary"
                  style={{
                    width: "98%",
                    height: "60px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host name( Your name or your company):
                </text>
                <input
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      host_name: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="Host name"
                  style={{
                    width: "98%",
                    height: "35px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host Phone Number:
                </text>
                <input
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      sellerPhone: e.target.value,
                    })
                  }
                  type="number"
                  maxLength={15}
                  pattern="[0-9]*"
                  placeholder="Phone Number"
                  style={{
                    width: "150px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host Email:
                </text>
                <input
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      sellerEmail: e.target.value,
                    })
                  }
                  type="email"
                  placeholder="Seller Email eg: johndoe@gmail.com"
                  style={{
                    width: "80%",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Been Hosting since what date ?
                </text>
                <input
                  // multiline={false}
                  onChange={(e) =>
                    setNewItem({ ...newItem, host_since: e.target.value })
                  }
                  type="text"
                  placeholder="eg: 08/23/2017"
                  style={{
                    width: "150px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host location :
                </text>
                <input
                  // multiline={false}
                  onChange={(e) =>
                    setNewItem({ ...newItem, host_location: e.target.value })
                  }
                  type="text"
                  placeholder="Your city, state, location"
                  style={{
                    width: "98%",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "10px",
                    margin: 0,
                    marginLeft: "3px",
                    padding: "5px",
                  }}
                >
                  Your About Inforamtion:
                </text>
                <textarea
                  rows={15}
                  cols={40}
                  onChange={(e) =>
                    setNewItem({ ...newItem, host_about: e.target.value })
                  }
                  type="text"
                  placeholder="information about you eg: your qualification,hobby etc"
                  style={{
                    width: "98%",
                    height: "50px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "1px",
                    padding: 5,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host response time :
                </text>
                <input
                  maxLength={10}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      host_response_time: e.target.value,
                    })
                  }
                  type="text"
                  placeholder="eg :1 hour"
                  style={{
                    width: "65px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Beds :
                </text>
                <input
                  maxLength={1}
                  onChange={(e) =>
                    setNewItem({ ...newItem, beds: e.target.value })
                  }
                  type="number"
                  placeholder="eg: 1 "
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Bathrooms :
                </text>
                <input
                  maxLength={1}
                  onChange={(e) =>
                    setNewItem({ ...newItem, bathrooms: e.target.value })
                  }
                  type="number"
                  placeholder="eg: 1"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "2px",
                  }}
                >
                  Host response rate
                </text>
                <input
                  maxLength={4}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      host_response_rate: e.target.value,
                    })
                  }
                  type="number"
                  placeholder="eg: 5"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />

                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Host acceptance rate:
                </text>
                <input
                  maxLength={4}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      host_acceptance_rate: e.target.value,
                    })
                  }
                  type="number"
                  placeholder="eg:5"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Price :$
                </text>
                <input
                  maxLength={6}
                  step="0.01"
                  onChange={(e) =>
                    setNewItem({ ...newItem, price: e.target.value })
                  }
                  type="number"
                  placeholder="eg: 200"
                  style={{
                    width: "65px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  # reviews:
                </text>
                <input
                  type="number"
                  maxLength={15}
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      number_of_reviews: e.target.value,
                    })
                  }
                  placeholder="eg: 257"
                  style={{
                    width: "100px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Guests included:
                </text>
                <input
                  maxLength={3}
                  onChange={(e) =>
                    setNewItem({ ...newItem, guests_included: e.target.value })
                  }
                  type="number"
                  placeholder="eg 2"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Bedrooms :
                </text>
                <input
                  maxLength={1}
                  onChange={(e) =>
                    setNewItem({ ...newItem, bedrooms: e.target.value })
                  }
                  type="number"
                  placeholder="eg:1"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Overall Rating :
                </text>
                <input
                  maxLength={4}
                  onChange={(e) =>
                    setNewItem({ ...newItem, ratings_Overall: e.target.value })
                  }
                  type="number"
                  step="0.01"
                  placeholder="eg:4.7"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Accuracy Rating:
                </text>
                <input
                  maxLength={4}
                  step="0.01"
                  onChange={(e) =>
                    setNewItem({ ...newItem, ratings_Accuracy: e.target.value })
                  }
                  type="number"
                  placeholder="eg: 5.0"
                  style={{
                    width: "65px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Check_in Rating
                </text>
                <input
                  maxLength={4}
                  step="0.01"
                  onChange={(e) =>
                    setNewItem({ ...newItem, ratings_Check_in: e.target.value })
                  }
                  type="number"
                  placeholder="eg: 4.9"
                  style={{
                    width: "65px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "4px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Communication rts
                </text>
                <input
                  maxLength={4}
                  step="0.01"
                  onChange={(e) =>
                    setNewItem({
                      ...newItem,
                      ratings_Communication: e.target.value,
                    })
                  }
                  type="number"
                  placeholder="eg:4.95"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />
                <br />
                <text
                  style={{
                    width: "98%",
                    height: "20px",
                    fontSize: "12px",
                    margin: 0,
                    padding: "5px",
                    marginLeft: "1px",
                  }}
                >
                  Location ratings:
                </text>
                <input
                  type="number"
                  maxLength={4}
                  step="0.01"
                  onChange={(e) =>
                    setNewItem({ ...newItem, ratings_Location: e.target.value })
                  }
                  placeholder="eg:5.0"
                  style={{
                    width: "55px",
                    height: "25px",
                    fontSize: "12px",
                    margin: 0,
                    marginLeft: "2px",
                    padding: 1,
                  }}
                />

                <button
                  type="submit"
                  style={{
                    height: "40px",
                    width: "95%",
                    marginLeft: "1px",
                    marginTop: "1px",
                    marginBottom: "10px",
                    fontWeight: 900,
                    borderRadius: 50,
                  }}
                >
                  Submit Apartment Details
                </button>
              </div>
            </form> */}
          </div>
          {/* </DialogContentText> */}
        </div>
        {/* <hr />
         */}

        <div>
          <Button style={{ color: "white" }} onClick={handleClose}>
            Close
          </Button>
        </div>
      </div>
    </div>
  );
}

// import React, { useState } from "react";
// import "./ProductUploadForm.css";
// import Button from "@mui/material/Button";
// import "./ProductUpload.css";
// import { useEffect } from "react";
// import { storage } from "../firebase";
// import {
//   ref as storageRef,
//   uploadBytesResumable,
//   getDownloadURL,
// } from "firebase/storage";
// import { collection } from "firebase/firestore";
// import { db as database } from "../firebase";
// import { useNavigate } from "react-router-dom";
// import { getDocs } from "firebase/firestore";
// import { useAlert } from "react-alert";

// export default function ProductUploadForm() {
//   const navigate = useNavigate();
//   const alert = useAlert();
//   const [open, setOpen] = React.useState(false);
//   const [file, setFile] = useState(null);
//   const [percent, setPercent] = useState(0);
//   const [downloadUrl, setDownloadUrl] = useState("");
//   const [mediaURL1, setMediaURL1] = useState("");
//   const [mediaURL2, setMediaURL2] = useState("");
//   const [mediaURL3, setMediaURL3] = useState("");
//   const [mediaURL4, setMediaURL4] = useState("");
//   const [mediaURL5, setMediaURL5] = useState("");
//   const [mediaURLCount, setMediaURLCount] = useState(1);
//   const [mediaURLType, setMediaURLType] = useState("");
//   const [fileType, setFileType] = useState("");
//   const [sellerId, setSellersId] = useState(null);
//   const [newItem, setNewItem] = useState({
//     id: "1",
//     title: "bag",
//     sellerEmail: "",
//     sellerPhone: "",
//     price: 99.99,
//     rating: 4,
//     ratings: 72,
//     image: "../images/bag.jpeg",
//     mediaURL1: "../images/bag.jpeg",
//     itemWeight: "",
//     packageWeight: "",
//     numberOfItems: 1,
//     unitCount: "1",
//     description1: "Milano 806017 21X12.4X4.6cm MP 3½",
//     categories: "Milano",
//     measure: "",
//     status: "active",
//     shipping: 9.99,
//     tax: 0.0,
//     promotion: "",
//   });
//   const handleFileChange = (e) => {
//     e.preventDefault();
//     const selectedFile = e.currentTarget.files?.[0] ?? null;
//     if (selectedFile) {
//       setFile(selectedFile);
//       setFileType(selectedFile.type); // Store the MIME type
//     }
//   };

//   const handleUpload = (e) => {
//     e.preventDefault();
//     if (!file) {
//       alert.show("Please select a file first!");
//       return;
//     }

//     const blob = file instanceof Blob ? file : null;
//     if (!blob) {
//       // console.error("Selected file is not a Blob object.");
//       return;
//     }

//     const fileName = `${Date.now()}_${file.name}`;
//     const storageReference = storageRef(storage, `uploads/${fileName}`);
//     const uploadTask = uploadBytesResumable(storageReference, blob);

//     uploadTask.on(
//       "state_changed",
//       (snapshot) => {
//         const perc = Math.round(
//           (snapshot.bytesTransferred / snapshot.totalBytes) * 100
//         );
//         setPercent(perc);
//       },
//       (error) => {
//         alert.show("Something is not right...Do you have internet ?");
//         // console.error("Upload failed:", error);
//       },
//       () => {
//         getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
//           setDownloadUrl(downloadURL);
//           setMediaURLType(fileType);
//           if (mediaURLCount === 1) {
//             setMediaURL1(downloadURL);
//             alert.show("First image uploaded !");
//           }
//           if (mediaURLCount === 2) {
//             setMediaURL2(downloadURL);
//             alert.show("Second image uploaded !");
//           }
//           if (mediaURLCount === 3) {
//             setMediaURL3(downloadURL);
//             alert.show("Third image uploaded !");
//           }
//           if (mediaURLCount === 4) {
//             setMediaURL4(downloadURL);
//             alert.show("Fort image uploaded !");
//           }
//           if (mediaURLCount === 5) {
//             setMediaURL5(downloadURL);
//             alert.show("Fifth ( the last ) image uploaded !");
//           }
//         });
//         setMediaURLCount(mediaURLCount + 1);
//       }
//     );
//   };
//   const onSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       // if (!(sellerId && mediaURL1)) return; // must save atleast 1 image
//       await saveRecord(
//         sellerId,
//         mediaURLType,
//         mediaURL1,
//         mediaURL2,
//         mediaURL3,
//         mediaURL4,
//         mediaURL5,
//         new Date().toISOString()
//       );
//       alert.show("detail saved succesfully !");

//       setMediaURL1("");
//       setMediaURL2("");
//       setMediaURL3("");
//       setMediaURL4("");
//       setMediaURL5("");
//       setDownloadUrl("");
//       setPercent(0);
//       handleClose();
//       setNewItem(null);
//       // close the form screen
//       // navigation.navigate("/Listfirestore");
//     } catch (error) {
//       alert.show("Something went wrong 1");
//       // alert.show("Error Adding Data");
//     }
//   };
//   async function saveRecord() {
//     try {
//     } catch (error) {
//       // console.log(error);
//       alert.show("Something went wrong !");
//     }
//   }
//   const handleClose = () => {
//     setOpen(false);

//     navigate("/Home");
//   };

//   useEffect(() => {
//     const fetchSellers = async () => {
//       const sellerDBRef = collection(database, "Seller");
//       const sellerSnapshot = await getDocs(sellerDBRef);
//       const sellerList = sellerSnapshot.docs.map((seller) => ({
//         connectedAccountId: seller.connectedAccountId,
//         ...seller.data(),
//       }));
//       setSellersId(sellerList[0]?.connectedAccountId);
//     };
//     if (sellerId === "") {
//       window.location.replace("/CompanyOnboardin");
//     } else if (sellerId !== "") {
//       // alert.show(`Welcome , Connected Account found `);
//     }
//     fetchSellers();
//   }, [sellerId, alert]);

//   return (
//     <div className="outercontainer">
//       <div
//         padding="0px"
//         width="98%"
//         open={open}
//         onClose={handleClose}
//         aria-labelledby="alert-dialog-title"
//         aria-describedby="alert-dialog-description"
//       >
//         <div padding={0}>
//           <div
//             style={{
//               display: "flex",
//               flexDirection: "row",
//               justifyContent: "left",
//               alignItems: "center",
//               // gap: 140,
//               paddingTop: "10px",
//               paddingLeft: "20px",
//               color: "white",
//               fontSize: "1rem",
//               marginTop: "120px",
//               boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//             }}
//           >
//             <br />
//             <input
//               type="file"
//               accept="image/*,video/*"
//               style={{
//                 height: "35px",
//                 borderRadius: 7,
//                 padding: 5,
//                 width: 100,
//               }}
//               onChange={handleFileChange}
//             />
//             <p
//               style={{
//                 padding: 5,
//               }}
//             >
//               <h6>Upload not more than Five images</h6>
//             </p>
//             <button
//               onClick={handleUpload}
//               style={{ height: "35px", borderRadius: 7, padding: 5 }}
//             >
//               Upload
//             </button>
//             {percent > 0 && (
//               <p>
//                 <h6>:{percent}% done</h6>
//               </p>
//             )}
//             {downloadUrl && (
//               <div>
//                 {file.type.startsWith("image") ? (
//                   <img
//                     src={downloadUrl}
//                     alt="uploaded"
//                     style={{ maxWidth: "20px" }}
//                   />
//                 ) : (
//                   <video
//                     src={downloadUrl}
//                     controls
//                     style={{ maxWidth: "20px" }}
//                   />
//                 )}
//               </div>
//             )}
//           </div>
//         </div>
//         <hr />
//         <div className="innercontainer">
//           <form
//             onSubmit={onSubmit}
//             className="emailForm"
//             width="100%"
//             style={{
//               alignItems: "left",
//               fontSize: "1rem",
//               marginTop: "120px",
//               boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)",
//             }}
//           >
//             <div style={{ marginLeft: "20px", marginTop: "2px" }}>
//               <h5>Enter the Product detail</h5>
//               <hr />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   // padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Seller ( Your name or your company):
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     seller: e.target.value,
//                   })
//                 }
//                 type="text"
//                 placeholder="Product seller"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Seller Phone Number:
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     sellerPhone: e.target.value,
//                   })
//                 }
//                 type="number"
//                 placeholder=" Seller Phone Number"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Seller Email:
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({
//                     ...newItem,
//                     sellerEmail: e.target.value,
//                   })
//                 }
//                 type="email"
//                 placeholder="Seller Email"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product category (categories :)
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, categories: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product category (categories)"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Title or Name :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, title: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product name"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "10px",
//                   margin: 0,
//                   marginLeft: "3px",
//                   padding: "5px",
//                 }}
//               >
//                 Product unit Price ( eg 34.99):
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, price: e.target.value })
//                 }
//                 type="number"
//                 maxLength={5}
//                 step="0.01"
//                 placeholder="Product price"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product description1 (statement1) :
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, description1: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product  statement1"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product description2 (statement2) :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, description2: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product  statement2"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product description3 (statement3):
//               </text>
//               <input
//                 multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, description3: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product  statement3"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product description4 (statement4):
//               </text>
//               <input
//                 multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, description4: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product  statement4"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product description5 (statement5) :
//               </text>
//               <input
//                 multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, description5: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product  statement5"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Rating (stars eg 4.5):
//               </text>
//               <input
//                 multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, rating: e.target.value })
//                 }
//                 type="number"
//                 maxLength={4}
//                 step="0.01"
//                 placeholder="Product rating"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Ratings Count (number of raters eg 200) :
//               </text>
//               <input
//                 maxLength={6}
//                 type="number"
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, ratings: e.target.value })
//                 }
//                 placeholder="Product ratings count"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Weight ( in lbs) :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, itemWeight: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Product Weight eg 1lb"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Total Package Weight :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, packageWeight: e.target.value })
//                 }
//                 type="text"
//                 placeholder="Package Weight eg 2lbs"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product Unit Count :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, title: e.target.value })
//                 }
//                 type="number"
//                 placeholder="Product Unit Count eg 1"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Total Counts :
//               </text>
//               <input
//                 // multiline={false}
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, numberOfItems: e.target.value })
//                 }
//                 type="number"
//                 placeholder="Product counts"
//                 style={{
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                 }}
//               ></input>
//               <br />
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Measure
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, measure: e.target.value })
//                 }
//                 type="text"
//                 placeholder="measure eg 5ozs"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>
//               <text
//                 style={{
//                   width: "98%",
//                   height: "20px",
//                   fontSize: "12px",
//                   margin: 0,
//                   padding: "5px",
//                   marginLeft: "1px",
//                 }}
//               >
//                 Product status (active or not)
//               </text>
//               <input
//                 onChange={(e) =>
//                   setNewItem({ ...newItem, status: e.target.value })
//                 }
//                 type="active"
//                 placeholder="Product status"
//                 style={{
//                   width: "98%",
//                   height: "35px",
//                   borderRadius: 7,
//                   padding: 5,
//                   fontSize: "12px",
//                   margin: 0,
//                   marginLeft: "1px",
//                 }}
//               ></input>

//               <button
//                 type="submit"
//                 style={{
//                   height: "40px",
//                   width: "99%",
//                   marginTop: "30px",
//                   marginBottom: "30px",
//                   borderRadius: 20,
//                 }}
//               >
//                 Submit Product Details
//               </button>
//             </div>
//           </form>
//         </div>

//         <div>
//           <Button style={{ color: "white" }} onClick={handleClose}>
//             Close
//           </Button>
//         </div>
//       </div>
//     </div>
//   );
// }
